import { useNavigate, useLocation } from "react-router-dom";
import { useSelectedDate } from "../context/SelectedDateContext";

export default function BackButton() {
  const navigate = useNavigate();
  const location = useLocation(); // Get current route
  const { selectedDate, selectedSchool } = useSelectedDate();

  const handleBack = () => {
    if (selectedDate || selectedSchool) {
      navigate(-1);
    } else if (
      location.pathname.startsWith("/admin") ||
      location.pathname.startsWith("/tbi")
    ) {
      navigate("/admin"); // Redirect to admin home if in admin panel
    } else {
      navigate("/"); // Default back to main home
    }
  };

  return (
    <div
      className="position-absolute start-0 fw-bold"
      style={{ marginLeft: "30px", marginTop: "-20px", cursor: "pointer" }}
      onClick={handleBack}
    >
      &lt; Voltar
    </div>
  );
}
